import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Alert from '../../../../../components/Alert';
import AlertButton from '../../../../../components/AlertButton';
import Tooltip from '../../../../../components/Tooltip';
import { i18nNS } from '../../../../../i18n';
import Trash2Icon from '../../../../../icons/Trash2Icon';
import useDeletePoll from './vm';

const DeletePoll = () => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY]);

  const { handleDeletePollAndRemoveFromSlide, handleRemoveFromSlide } = useDeletePoll();

  return (
    <Tooltip title={t('delete_poll', { ns: i18nNS.POLL })}>
      <AlertButton
        variant="text"
        color="error"
        size="small"
        aria-label={t('click_to_delete_poll', { ns: i18nNS.POLL })}
      >
        <Trash2Icon size={20} aria-hidden />
        <Alert maxWidth="xs">
          <Alert.Header>{t('delete_poll', { ns: i18nNS.POLL })}</Alert.Header>
          <Alert.Body>
            <Stack gap={2}>
              <Alert.Action
                variant="contained"
                color="error"
                size="small"
                onClick={handleRemoveFromSlide}
                aria-label={t('click_to_remove_poll_from_this_slide', { ns: i18nNS.POLL })}
              >
                {t('remove_from_slide', { ns: i18nNS.POLL })}
              </Alert.Action>
              <Alert.Action
                variant="outlined"
                color="error"
                size="small"
                onClick={handleDeletePollAndRemoveFromSlide}
                aria-label={t('click_to_delete_poll_and_remove_from_slide', { ns: i18nNS.POLL })}
              >
                {t('delete_poll_and_remove_from_slide', { ns: i18nNS.POLL })}
              </Alert.Action>
              <Alert.Action
                variant="text"
                size="small"
                aria-label={t('click_to_cancel_deleting_this_poll', {
                  ns: i18nNS.POLL,
                })}
              >
                {t('cancel', { ns: i18nNS.GLOSSARY })}
              </Alert.Action>
            </Stack>
          </Alert.Body>
        </Alert>
      </AlertButton>
    </Tooltip>
  );
};

export default DeletePoll;
